class InteractiveCalendar {
    constructor() {
        const cards = document.querySelectorAll('.interactive-calendar__card');

        if (!cards.length) {
            return;
        }

        this.initializeCards(cards, true);
        this.attachEventListeners(this, cards)
        this.attachIntersectionObserver();
    }

    attachIntersectionObserver() {
        const watcher = [...document.querySelectorAll('.interactive-calendar__cards .interactive-calendar__card')][0]
        const options = {
            rootMargin: "0px",
            threshold: 0.75
        };
        const observer = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    watcher.classList.add('interactive-calendar__card--wiggle');
                    setTimeout(() => {
                        watcher.classList.remove('interactive-calendar__card--wiggle');
                        observer.unobserve(entry.target);
                    }, 1500)
                } else {
                    watcher.classList.remove('interactive-calendar__card--wiggle');
                }
            });
        }, options);

        observer.observe(watcher);
    }

    attachEventListeners(self, cards) {
        cards.forEach(function (el) {
            const hammertime = new Hammer(el);

            hammertime.on('pan', function (e) {
                e.preventDefault();
                el.classList.add('moving');
            });

            hammertime.on('pan', function (e) {
                e.preventDefault();
                if (e.deltaX === 0)
                    return;
                if (e.center.x === 0 && e.center.y === 0)
                    return;

                const xMulti = e.deltaX * 0.03;
                const yMulti = e.deltaY / 80;
                const rotate = ((xMulti * yMulti) / 5);

                e.target.style.transform = 'translate(' + e.deltaX + 'px, ' + e.deltaY + 'px) rotate(' + rotate + 'deg)';
            });

            hammertime.on('panend', function (e) {
                el.classList.remove('moving');
                const moveOutWidth = document.body.clientWidth;
                e.target.classList.toggle('interactive-calendar__card--removed');

                const endX = Math.max(Math.abs(e.velocityX) * moveOutWidth, moveOutWidth);
                const toX = e.deltaX > 0 ? endX : -endX;
                const endY = Math.abs(e.velocityY) * moveOutWidth;
                const toY = e.deltaY > 0 ? endY : -endY;
                const xMulti = e.deltaX * 0.03;
                const yMulti = e.deltaY / 80;
                const rotate = ((xMulti * yMulti) / 5);

                e.target.style.transform = 'translate(' + toX + 'px, ' + (toY + e.deltaY) + 'px) rotate(' + rotate + 'deg)';
                self.initializeCards(cards, true);
            });
        });


        const previousButtons = document.querySelectorAll('.interactive-calendar__button.interactive-calendar__button--previous');
        previousButtons.forEach(function (previousButton) {
            previousButton.addEventListener('click', () => self.previousOrNextButtonOnClick(false, self));
        });

        const nextButtons = document.querySelectorAll('.interactive-calendar__button.interactive-calendar__button--next');
        nextButtons.forEach(function (nextButton) {
            nextButton.addEventListener('click', () => self.previousOrNextButtonOnClick(true, self));
        });

        const timelineButtons = document.querySelectorAll('.interactive-calendar__timeline-item');
        timelineButtons.forEach(function (timelineButton) {
            timelineButton.addEventListener('click', (e) => self.handleTimelineButtonOnClick(e, self));
        });
    }

    initializeCards(cards, next) {
        const newCards = document.querySelectorAll('.interactive-calendar__card:not(.interactive-calendar__card--removed)');

        newCards.forEach(function (card, index) {
            card.style.zIndex = cards.length - index;
            if (index === 0) {
                card.style.transform = '';
            } else if (index === 1) {
                card.style.transform = 'rotate(3.5deg)';
            } else if (index === 2) {
                card.style.transform = 'rotate(1deg)';
            } else {
                card.style.transform = 'rotate(-1.5deg)';
            }
        });

        const removedCards = document.querySelectorAll('.interactive-calendar__card.interactive-calendar__card--removed');
        if (removedCards.length) {
            removedCards.forEach(function (card) {
                if (next) {
                    card.parentNode.appendChild(card);
                }
                else {
                    card.parentNode.insertBefore(card, card.parentNode.firstChild);
                }
                card.classList.remove('interactive-calendar__card--removed');
            });

            this.initializeCards(cards, next);
        }

        const currentCard = [...document.querySelectorAll('.interactive-calendar__cards .interactive-calendar__card')][0]
        const currentTitle = currentCard.getElementsByClassName('interactive-calendar__card-title')[0];

        const timelineTags = document.querySelectorAll('.interactive-calendar__timeline-tag');
        timelineTags.forEach(function (tag) {
            tag.innerText = currentTitle.innerText;
        });

        const timelineItems = new Set(document.querySelectorAll('.interactive-calendar__timeline-item'));

        timelineItems.forEach(function (item) {
            if (currentCard.dataset.card === item.dataset.card) {
                if (item.classList.contains('interactive-calendar__timeline-item--active')) {
                    const event = new Event('changedcard');
                    event.card = currentCard;
                    event.cardNumber = currentCard.dataset.card;
                    event.totalCards = cards.length;
                    item.dispatchEvent(event);
                }
                item.classList.add('interactive-calendar__timeline-item--active');
            } else {
                item.classList.remove('interactive-calendar__timeline-item--active');
            }
        });

        document.querySelector('.interactive-calendar__cards').classList.add('interactive-calendar__cards--loaded');
    }

    previousOrNextButtonOnClick(next, self) {
        const cards = document.querySelectorAll('.interactive-calendar__card:not(.interactive-calendar__card--removed)');

        if (!cards.length)
            return false;

        if (next) {
            const card = cards[0];
            card.classList.add('interactive-calendar__card--removed');
        }
        else {
            const card = cards[cards.length - 1];
            card.classList.add('interactive-calendar__card--removed');
        }

        const allCards = document.querySelectorAll('.interactive-calendar__card');
        self.initializeCards(allCards, next);
    }

    handleTimelineButtonOnClick(e, self) {
        const targetCardId = e.target.dataset.card;
        const CARDS_SELECTOR = '.interactive-calendar__card:not(.interactive-calendar__card--removed)';
        let currentCardId = parseInt(document.querySelectorAll(CARDS_SELECTOR)[0].dataset.card);

        if (targetCardId > currentCardId) {
            do {
                self.previousOrNextButtonOnClick(true, self);
                currentCardId = parseInt(document.querySelectorAll(CARDS_SELECTOR)[0].dataset.card);
            } while (targetCardId > currentCardId)
        }
        else if (targetCardId < currentCardId) {
            do {
                self.previousOrNextButtonOnClick(false, self);
                currentCardId = parseInt(document.querySelectorAll(CARDS_SELECTOR)[0].dataset.card);
            } while (targetCardId < currentCardId)
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new InteractiveCalendar();
});